<script setup lang="ts">
import { ConfigProvider } from 'reka-ui'
import { RouterView } from 'vue-router'

import AppToastHost from '@/shared/ui/toast/AppToastHost.vue'
</script>

<template>
  <!-- The root keeps its scrollbar gutter, so a scroll lock needs no padding compensation. -->
  <ConfigProvider :scroll-body="false">
    <RouterView />
    <AppToastHost />
  </ConfigProvider>
</template>
